import { IntlShape } from "react-intl";
import { createLocalizedOptions } from "../options";
import { Options } from "../../components/atoms/inputs/FlowioSelect/types";

export const makeRoleTypeOptions = (intl: IntlShape) =>
  createLocalizedOptions(intl, [
    ["guest", "roles.guest"],
    ["editor", "roles.editor"],
  ]);

export const enumToOptionArray = (
  parameters: Record<string, string>
): Options =>
  Object.keys(parameters).map((key) => ({
    value: parameters[key],
    name: key,
  }));
